import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import AppV3 from "@/AppV3";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppV3 />} />
        <Route path="*" element={<AppV3 />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
